/**
 * Complete Draft Utility
 * Call this function when a draft quote is converted to a pending/accepted quote
 */

import { clearDraftFromStorage } from './draftStorage';

/**
 * Mark a draft as completed and clear from localStorage
 * 
 * Usage: Call this when:
 * - User clicks "Book Job" and quote is successfully created
 * - User clicks "Send Quote" and quote is sent
 * - Draft is converted from 'draft' status to 'pending'/'accepted'
 * 
 * @param draftSlug - The slug of the draft being completed (for logging)
 */
export const completeDraft = (draftSlug?: string): void => {
  clearDraftFromStorage();
  
  if (draftSlug) {
    console.log('[Lead Capture] Draft completed and cleared from storage:', draftSlug);
  } else {
    console.log('[Lead Capture] Draft session cleared from storage');
  }
};

/**
 * Example usage in SummaryStep when implementing "Book Job":
 * 
 * ```typescript
 * import { completeDraft } from '../utils/completeDraft';
 * 
 * const handleBookJob = async () => {
 *   try {
 *     // Create quote/charges and convert draft to pending
 *     const response = await callServerAction({
 *       url: 'quote/with-charges',
 *       method: 'post',
 *       data: {
 *         draftQuoteId: draftQuoteId, // Pass existing draft ID
 *         quote: { ...quoteData },
 *         charges: { ...chargeData }
 *       }
 *     });
 *     
 *     if (response) {
 *       // Success! Clear the draft from localStorage
 *       completeDraft(draftQuoteSlug);
 *       // Navigate to confirmation page
 *       router.push(`/confirmation/${response._id}`);
 *     }
 *   } catch (error) {
 *     console.error('Failed to book job:', error);
 *   }
 * };
 * ```
 */

